import { getImageUrlFromCdn } from './get-image-url-from-cdn';
import { getTeamLogosUrls } from './get-team-logos-urls';
import defaultTournamentLogo from './images/default-tournament-logo-50.svg';

export {
  getImageUrlFromCdn,
  getTeamLogosUrls,
  defaultTournamentLogo,
};
